<template>
  <router-view></router-view>
</template>
<script>
import "@/assets/js/bootstrap-switch-button.min";
</script>

<style lang="scss">
@font-face {
  font-family: "unicons";
  src: url("./assets/fonts/unicons.eot");
  src: url("./assets/fonts/unicons.eot") format("embedded-opentype"),
    url("./assets/fonts/unicons.woff") format("woff"),
    url("./assets/fonts/unicons.ttf") format("truetype"),
    url("./assets/fonts/unicons.svg") format("svg");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Gotham-Rounded";
  src: url("./assets/fonts/Gotham-Rounded-Bold.ttf") format("truetype"),
    url("./assets/fonts/Line-Awesome.woff?15lwq9") format("woff"),
    url("./assets/fonts/Line-Awesome.svg?15lwq9#Line-Awesome") format("svg");
  font-weight: normal;
  font-style: normal;
}

/* Brand-Icons, Line-Awesome, Feather-Icons: icons.css ve line-awesome.css içinde tanımlı */

//@font-face {
//  font-family: 'Material Icons';
//  font-style: normal;
//  font-weight: 400;
//  src: url(./assets/fonts/MaterialIcons-Regular.eot);
//  /* For IE6-8 */
//  src: local('Material Icons'),
//  local('MaterialIcons-Regular'),
//  url(./assets/fonts/MaterialIcons-Regular.woff2) format('woff2'),
//  url(./assets/fonts/MaterialIcons-Regular.woff) format('woff'),
//  url(./assets/fonts/MaterialIcons-Regular.ttf) format('truetype');
//}

// 3rd party plugins css
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "~bootstrap-select/dist/css/bootstrap-select.css";
@import "~perfect-scrollbar/css/perfect-scrollbar.css";
@import "~@fortawesome/fontawesome-free/css/all.css";
@import "~line-awesome/dist/line-awesome/css/line-awesome.css";
@import "assets/plugins/flaticon/flaticon.css";
@import "assets/plugins/flaticon2/flaticon.css";
@import "assets/plugins/keenthemes-icons/font/ki.css";

@import "assets/css/style.css";
@import "assets/css/night-mode.css";
@import "assets/css/framework.css";
@import "assets/css/bootstrap.css";
@import "assets/css/responsive.css";
@import "assets/css/icons.css";
@import "assets/scss/style.scss";
@import "assets/scss/responsive.scss";
@import "assets/css/bootstrap-switch-button.min.css";

// Main demo style scss
//@import "assets/sass/style.vue";

// Check documentation for RTL css
/*@import "assets/css/style.vue.rtl";*/
</style>

<script>
import Vue from "vue";
import VueCardFormat from "vue-credit-card-validation";
Vue.use(VueCardFormat);

import {
  LOGIN,
  LOGOUT,
  SEND_SMS,
  SET_ERROR,
  GET_USER_WITH_TOKEN,
} from "@/core/services/store/auth.module";
import { GET_ITEMS } from "@/core/services/store/REST.module";
import bridge from "@/core/services/bridge.service";
export default {
  name: "MetronicVue",
  computed: {
    userInfo: {
      get: function () {
        return this.authUser;
      },
      set: function (newValue) {},
    },
    user_header: {
      get() {
        if (this.secureLocalStorage("user"))
          return JSON.parse(this.secureLocalStorage("user"));
        else return [];
      },
      set() {},
    },
  },
  beforeMount() {
    this.setFaviconByDomain();

    if (this.userInfo) {
      document.title = this.userInfo.company_name;
    }
  },
  methods: {
    superAdmin() {
      if (this.user_header === null || !("roles" in this.user_header)) {
        return false;
      }
      if (this.user_header.roles.length > 2) {
        return true;
      } else {
        return false;
      }
    },
    isValidRoute(path) {
      const cleanPath = path.split("?")[0].trim();
      const blockedRoutes = ["/403", "/404", "/500"];
      if (blockedRoutes.includes(cleanPath)) {
        return false;
      }
      const resolved = this.$router.resolve(cleanPath);
      return (
        resolved &&
        resolved.resolved &&
        Array.isArray(resolved.resolved.matched) &&
        resolved.resolved.matched.length > 0
      );
    },
    /**
     * Girişten sonra dönülecek hedefi saklar. Yalnızca adreste gerçek bir
     * hedef sayfa varsa yazar; giriş/anasayfa adresleri atlanır.
     */
    rememberRedirectTarget() {
      const attemptedPath = window.location.hash.substring(1);
      const cleanPath = attemptedPath.split("?")[0].trim();

      if (!cleanPath || ["/", "/login", "/homepage"].includes(cleanPath)) {
        return;
      }

      if (!this.isValidRoute(attemptedPath)) {
        return;
      }

      window.localStorage.setItem("redirect_url", attemptedPath);
    },
    setFaviconByDomain() {
      const subdomain = window.location.hostname;

      let iconPath = "/favicon.ico";

      const isAto = subdomain === "ato.softinya.com" || subdomain === "akademi.atonet.org.tr";

      if (isAto) {
        iconPath = "/favicon-ato.png";
      }

      document
        .querySelectorAll("link[rel*='icon']")
        .forEach((el) => el.parentNode.removeChild(el));

      const link = document.createElement("link");
      link.rel = "icon";
      link.type = "image/png";
      link.href = iconPath;
      document.head.appendChild(link);
    },
  },
  created() {
    // Mobil'den gelen NAVIGATE mesajını dinle (bildirim tıklama vb.)
    if (bridge.isNative) {
      bridge.on('NAVIGATE', (payload) => {
        if (payload && payload.path) {
          this.$router.push({ path: payload.path }).catch(() => {});
        }
      });
    }
  },
  mounted() {
    let subdomain = window.location.host.split(".")[0];
    let domain = process.env.VUE_APP_APP_URL;
    let parsedDomain = new URL(domain).host;
    const isAuthenticated = this.$store.getters.isAuthenticated;
    const currentUser = this.$store.getters.currentUser;
    const access_token = new URLSearchParams(window.location.search).get(
      "token"
    );

    const isAuthPage = [
      "#/create-password",
      "#/reset-password",
      "#/forgot-password",
    ].some((path) => window.location.href.includes(path));

    // 🔹 1️⃣ - Handle short link redirect (/s/)
    if (window.location.href.includes("/s/")) {
      const shortToken = window.location.href.split("/s/")[1];
      this.$store
        .dispatch(GET_ITEMS, {
          url: "api/s/" + shortToken,
          acceptPromise: false,
        })
        .then((response) => {
          if (response?.status) {
            window.location.href = response.data;
          } else {
            this.$router.push({ path: "/404" });
          }
        })
        .catch(() => {
          this.$router.push({ path: "/404" });
        });
      return;
    }

    // 🔹 2️⃣ - Skip redirect logic on authentication-related pages
    if (isAuthPage) {
      return;
    }

    // 🔹 3️⃣ - If token exists in URL, go directly to dashboard
    if (access_token) {
      this.$router.push({ path: "/dashboard" });
      return;
    }

    // 🔹 5️⃣ - Detect main domain
    const isMainDomain =
      window.location.hostname === "www.softinya.com" ||
      window.location.hostname === "softinya.com" ||
      window.location.hostname === "www.zorunluegitimler.com" || 
      window.location.hostname === "zorunluegitimler.com" ||
      window.location.hostname === "localhost";

    // 🔹 4️⃣ - If user is not authenticated, go to homepage
    if (!isAuthenticated && !currentUser) {
      // Deep link / paylaşılan link ile gelindiyse hedef sayfayı sakla;
      // giriş sonrası Login.vue redirect_url ile buraya geri döner.
      this.rememberRedirectTarget();

      if (window.location.hash === "#/homepage") return;
      this.$router.push({ path: "/homepage" });
      return;
    }

    // If main domain and hash === "#/", go to homepage
    if (window.location.hash === "#/" && isMainDomain) {
      this.$router.push({ path: "/homepage" });
      return;
    }

    // 🔹 6️⃣ - Handle redirect URL logic
    const currentPath = window.location.hash.substring(1);
    let redirectUrl = window.localStorage.getItem("redirect_url");

    // If redirect URL is missing or invalid, set a valid one
    if (!redirectUrl || !this.isValidRoute(redirectUrl)) {
      redirectUrl = this.isValidRoute(currentPath) ? currentPath : "/dashboard";
      window.localStorage.setItem("redirect_url", redirectUrl);
    }

    // If redirect URL is root or login, default to dashboard
    if (["/", "/login"].includes(redirectUrl)) {
      redirectUrl = "/dashboard";
      window.localStorage.setItem("redirect_url", redirectUrl);
    }

    // 🔹 7️⃣ - If hash is "#/" but not main domain, go to dashboard
    if (window.location.hash === "#/" && !isMainDomain) {
      this.$router.push({ path: "/dashboard" });
      return;
    }

    // 🔹 8️⃣ - If there is no hash or it's empty, go to redirect URL
    if (!window.location.hash || window.location.hash === "") {
      this.$router.push({ path: redirectUrl });
    }
  },
};
</script>
<style>
body {
  overflow-y: scroll !important;
  height: 100vh !important;
}
.uk-tooltip {
  color: #ffffff !important;
}

/* :root {
  --backgroundColor: #ff11007e;
  --white: #121110;
} */
</style>
